import React from 'react';
import cn from 'classnames';
import BlueBookButton from '../bluebook-button/BlueBookButton';

const BluebookLinkButton = ({
  children,
  onClick,
  accessibility = {},
  className = '',
}) => (
  <BlueBookButton
    accessibility={accessibility}
    onClick={onClick}
    className={cn(
      className,
      'bg-none text-bluebook-blue border-none hover:underline mb-3 text-base !font-medium !py-[7px] !px-[23px] !h-auto !rounded-none',
    )}
  >
    {children}
  </BlueBookButton>
);

export default BluebookLinkButton;
